import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { IPodWebExtensionConfiguration } from 'services/webExtension/types';

export const getDefaultPsaId = (
  crmType: string,
): IResponse<number> =>
  axiosInstance.request({
    method: 'GET',
    url: `PodWebExtensions/crm?crmType=${crmType}`,
  });

export const getPodConfiguration = (): IResponse<IPodWebExtensionConfiguration> =>
  axiosInstance.request({
    method: 'GET',
    url: 'PodWebExtensions/configuration',
    validateStatus: () => true,
  });
